import { useState } from 'react'
import { IDocumentTypeId } from '~/@api/generated-api-types-document/Api'
import type { ObjectValues } from '~/@lib/utils/type.utils'

const FilterId = {
  ALL: 1,
  REGISTER: 2,
  ORDER: 3,
  FEE_SUMMARY_STATEMENT: 4,
} as const

function useFilterTypeIds() {
  const [filterId, setFilterId] = useState<ObjectValues<typeof FilterId>>(
    FilterId.ALL
  )
  const filterTypes = [
    {
      text: 'Všetky',
      value: [],
      id: FilterId.ALL,
    },
    {
      text: 'Registrácia',
      value: [IDocumentTypeId.Main, IDocumentTypeId.Info] as const,
      id: FilterId.REGISTER,
    },
    {
      text: 'Investícia',
      value: [IDocumentTypeId.Kyc, IDocumentTypeId.Order] as const,
      id: FilterId.ORDER,
    },
    {
      text: 'Výpis poplatkov',
      value: [IDocumentTypeId.FeeSummaryStatement] as const,
      id: FilterId.FEE_SUMMARY_STATEMENT,
    },
  ]

  return { filterId, setFilterId, filterTypes }
}

export { useFilterTypeIds }
